enum ScreenSize {
  Mobile = 'sm',
  Tablet = 'md',
  Desktop = 'lg',
}

export default ScreenSize;
